import React from 'react'

import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenuItemUrl from "../../menu-items/menu-item-url"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"

type Props = {
    navigationSection   : NavigationSection
}

export default function NavigationMenuToolsCrm(props:Props) {

    const isManager = gd.user.acl.isManager

    // gd.company.settings.modules.crmContact.contactTypes - the company's CRM contact types
    const contactTypes: Options = gd.company.settings.modules.crmContact.contactTypes ?? []

    return (
        <>
            <NavigationMenuSection
                name        = "CRM"
                collapsible = {true}
                systemName  = "toolsCrm"
                counter     = {3 + contactTypes.length}
            >

                <NavigationMenuItemUrl
                    name                = "General"
                    icon                = "i5-crm-contact"
                    url                 = "crm/contacts/no-type"
                    navigationSection   = {props.navigationSection}
                />

                {_.map(contactTypes, (contactType: Option) => {
                    return (
                        <NavigationMenuItemUrl
                            key                 = {contactType.value}
                            name                = {contactType.label}
                            icon                = "i5-crm-contact"
                            url                 = {`crm/contacts/type/${contactType.value}`}
                            navigationSection   = {props.navigationSection}
                        />
                    )
                })}

                <NavigationMenuItemUrl
                    name                = "All contacts"
                    icon                = "i5-crm-contact"
                    url                 = "crm/contacts"
                    exactUrl            = {true}
                    navigationSection   = {props.navigationSection}
                />

                <div className="separator-h-small m-t-10 m-b-10"/>

                <NavigationMenuItemUrl
                    name                = "Companies"
                    icon                = "i5-crm-account"
                    url                 = "crm/companies"
                    navigationSection   = {props.navigationSection}
                />

            </NavigationMenuSection>

            {isManager &&
                <NavigationMenuSection
                    name        = "Customer Portal"
                    collapsible = {true}
                    systemName  = "crm-customer-portal"
                    counter     = {2}
                >
                    <NavigationMenuItemUrl
                        name                = "Customers"
                        icon                = "i5-customer"
                        url                 = "o/customers"
                        navigationSection   = {props.navigationSection}
                    />
                    <NavigationMenuItemUrl
                        name                = "Customer Projects"
                        icon                = "ii5-project"
                        url                 = "crm/projects"
                        navigationSection   = {props.navigationSection}
                    />
                </NavigationMenuSection>
            }
        </>
    )
}
